// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1gAkm","messages":"Chat_messages__AdZ81","dateDivider":"Chat_dateDivider__2aJ4n"};